import * as React from "react";
import { Link, NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import cqsLogoImage from "./../img/cqs-logo.png";
import logoImage from "./../img/logo.png";

interface SidebarProps extends RouteComponentProps<{}, {}> { }

export const Sidebar: React.FC<SidebarProps> = ({ location }) => {

    const [isProjectsOpen, setIsProjectsOpen] = React.useState(false);
    const [isCustomersOpen, setIsCustomersOpen] = React.useState(false);

    const toggleProjects = () => {
        setIsProjectsOpen(!isProjectsOpen);
    };

    const toggleCustomers = () => {
        setIsCustomersOpen(!isCustomersOpen);
    };

    const clearDataTableState = () => {
        Object.keys(localStorage)
            .filter(key => key.startsWith("DataTables_"))
            .forEach(key => localStorage.removeItem(key));
    };

    const shouldKeepOpen = location.pathname === "/jobs-bqs" || location.pathname === "/jobs-bc";
    const shouldKeepCustomersOpen = location.pathname === "/customers-bqs" || location.pathname === "/customers-bc" || location.pathname.startsWith("/customers/");

    return (
        <div
            className="sidebar"
            style={{ position: "fixed", top: 0, left: 0, height: "100%", overflowY: "auto" }}
        >
            {BQS && (
                <Link to="/" onClick={clearDataTableState}>
                    <img src={logoImage} alt="Logo" className="sidebar__logo" />
                </Link>
            )}
            {CQS && (
                <Link to="/" onClick={clearDataTableState}>
                    <img src={cqsLogoImage} alt="Logo" className="sidebar__logo" />
                </Link>
            )}
            <nav className="sidebar-nav">
                <ul className="nav">
                    <li className="nav-item">
                        <NavLink exact to="/" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                            <i className="icon-dashboard-black"></i> Dashboard
                        </NavLink>
                    </li>

                    {/* Projects with sub-menu */}
                    <li className="nav-item">
                        <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); toggleProjects(); }}
                            className="nav-link"
                            role="button"
                            aria-expanded={isProjectsOpen}
                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                        >
                            <span>
                                <i className="icon-jobs"></i> Projects
                            </span>
                            <span style={{ paddingRight: '15px' }}>
                                {(isProjectsOpen || shouldKeepOpen) ? '-' : '+'}
                            </span>
                        </a>
                        <ul className={`nav sub-menu ${(isProjectsOpen || shouldKeepOpen) ? 'open-submenu' : ''}`} style={{ paddingLeft: '20px' }}>
                            <li className="nav-item">
                                {BQS && (
                                    <NavLink to="/jobs-bqs" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                        <i className="icon-jobs"></i> BQS
                                    </NavLink>
                                )}
                                {CQS && (
                                    <NavLink to="/jobs-bqs" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                        <i className="icon-jobs"></i> CQS
                                    </NavLink>
                                )}
                            </li>
                            <li className="nav-item">
                                <NavLink to="/jobs-bc" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                    <i className="icon-jobs"></i> Business Central
                                </NavLink>
                            </li>
                        </ul>
                    </li>


                    {/* Customers with sub-menu */}
                    <li className="nav-item">
                        <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); toggleCustomers(); }}
                            className="nav-link"
                            role="button"
                            aria-expanded={isCustomersOpen}
                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                        >
                            <span>
                                <i className="icon-customers-black"></i> Customers
                            </span>
                            <span style={{ paddingRight: '15px' }}>
                                {(isCustomersOpen || shouldKeepCustomersOpen) ? '-' : '+'}
                            </span>
                        </a>
                        <ul className={`nav sub-menu ${(isCustomersOpen || shouldKeepCustomersOpen) ? 'open-submenu' : ''}`} style={{ paddingLeft: '20px' }}>
                            <li className="nav-item">
                                {BQS && (
                                    <NavLink to="/customers-bqs" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                        <i className="icon-customers-black"></i> BQS
                                    </NavLink>
                                )}
                                {CQS && (
                                    <NavLink to="/customers-bqs" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                        <i className="icon-customers-black"></i> CQS
                                    </NavLink>
                                )}
                            </li>
                            <li className="nav-item">
                                <NavLink to="/customers-bc" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                                    <i className="icon-customers-black"></i> Business Central
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/sections"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-sections-black"></i> Categories
                        </NavLink>
                    </li>
                    {BQS && <li className="nav-item">
                        <NavLink
                            to="/kits"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-product-kits-black"></i> Kits
                        </NavLink>
                    </li>
                    }
                    <li className="nav-item">
                        <NavLink
                            to="/products"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-products-black"></i> Items
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/quotes" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                            <i className="icon-quotes-black"></i> Quotes
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/reports"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-reports-black"></i> Reports
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/users" className="nav-link" activeClassName="active" onClick={clearDataTableState}>
                            <i className="icon-users1"></i> Users
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/vendors"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-vendors-black"></i> Vendors
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/settings"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-settings"></i> Settings
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            exact
                            to="/search"
                            className="nav-link"
                            activeClassName="active"
                            onClick={clearDataTableState}
                        >
                            <i className="icon-search1"></i> Inquire
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./ClientApp/components/Sidebar.tsx